import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Sedancabbookingpune() {



  const cardData = {




keyword: "Sedan Cab Booking Pune",

headingDescription: "Garud Cab Service provides comfortable and reliable Sedan Cab Booking in Pune for airport transfers, corporate travel, family journeys, railway station transfers, local sightseeing, outstation trips, and long-distance transportation. Our chauffeur-driven sedans are suitable for individuals, couples, and small families looking for a private and convenient travel option. Customers can book a sedan for one-way journeys, round trips, airport pickup and drop, business travel, hotel transfers, and customized travel plans. With clean and well-maintained vehicles, experienced drivers, flexible pickup locations, transparent pricing, and 24/7 customer assistance, Garud Cab Service offers a dependable cab booking experience from Pune to destinations across Maharashtra and nearby states.",

topPlaces: [
  {
    title: "Bhimashankar",
    description: "Bhimashankar is a revered pilgrimage destination in the Sahyadri ranges and is known for the Bhimashankar Jyotirlinga Temple surrounded by lush forests and mountain scenery. It is a popular choice for devotees, families, and nature lovers traveling from Pune. A private sedan is suitable for smaller groups who want a comfortable journey with flexible stops and convenient door-to-door transportation."
  },
  {
    title: "Panchgani",
    description: "Panchgani is a beautiful hill station known for Table Land, scenic valleys, viewpoints, strawberry farms, and pleasant weather. It is ideal for couples and families planning a peaceful getaway from Pune. Garud Cab Service provides chauffeur-driven sedan bookings for direct travel, return journeys, and customized sightseeing, allowing passengers to explore Panchgani according to their preferred schedule."
  },
  {
    title: "Malshej Ghat",
    description: "Malshej Ghat is a scenic Western Ghats destination famous for misty mountains, waterfalls, deep valleys, and winding roads. The region is particularly attractive during the monsoon and is popular among nature lovers and weekend travelers. Customers can book a sedan from Pune for a private and comfortable journey, with flexible stopping options for viewpoints and nearby attractions."
  },
  {
    title: "Bhandardara",
    description: "Bhandardara is a peaceful lakeside destination surrounded by mountains, forests, waterfalls, and scenic landscapes. Arthur Lake and Randha Falls are among the attractions that make the region popular for weekend trips. A sedan cab is a practical option for couples and small families traveling from Pune, offering private transportation, comfortable seating, and convenient luggage space."
  },
  {
    title: "Dapoli",
    description: "Dapoli is a scenic Konkan destination known for beaches, coastal villages, temples, greenery, and a relaxed holiday atmosphere. The longer road journey from Pune is convenient in a private sedan for couples and small families. Garud Cab Service offers flexible booking options for direct Dapoli travel, round trips, and customized coastal sightseeing with a professional chauffeur."
  },
  {
    title: "Kashid",
    description: "Kashid is a popular coastal getaway known for its sandy beach, clear sea views, greenery, and peaceful surroundings. It is suitable for couples and families looking for a relaxing beach trip from Pune. A sedan provides comfortable private transportation for smaller groups carrying moderate luggage, while customers can customize their route to include nearby coastal attractions."
  },
  {
    title: "Panhala",
    description: "Panhala is a historic hill destination near Kolhapur known for its impressive fort, scenic surroundings, and connection with Maratha history. It is a suitable destination for history enthusiasts and families planning a short road trip from Pune. Garud Cab Service provides chauffeur-driven sedan bookings for direct travel, return journeys, and sightseeing around Panhala and nearby areas."
  },
  {
    title: "Narsobawadi",
    description: "Narsobawadi is an important pilgrimage destination associated with Lord Dattatreya and Shri Narasimha Saraswati and is situated near the Krishna River. Devotees visit the town for its peaceful spiritual atmosphere and religious significance. Travelers from Pune can book a sedan for a comfortable pilgrimage journey and include nearby temples and religious locations in a customized itinerary."
  },
  {
    title: "Tarkarli",
    description: "Tarkarli is a beautiful Konkan destination known for its beaches, coastal scenery, clear waters, and traditional village surroundings. It is a suitable choice for travelers planning an extended beach holiday from Pune. A sedan cab offers a private and comfortable road-trip option for couples and small families, with flexible travel arrangements and convenient pickup facilities."
  },
  {
    title: "Satara",
    description: "Satara is a scenic Maharashtra destination surrounded by the Sahyadri ranges and known for attractions such as Kaas Plateau, Thoseghar Waterfalls, and historic forts. It is suitable for families, nature lovers, and weekend travelers from Pune. Customers can book a sedan for direct travel or create a customized sightseeing itinerary covering Satara and nearby attractions."
  }
],




"services": [
{
"name": "Sedan Cab Service in Pune",
"description": "Book Sedan Cab Service in Pune for comfortable and reliable local, airport, and outstation transportation with professional chauffeurs and well-maintained air-conditioned sedan cars. The service is suitable for individuals, families, tourists, corporate travelers, airport transfers, city travel, and planned one-way or round-trip journeys."
},
{
"name": "Sedan Taxi Service Pune",
"description": "Choose Sedan Taxi Service Pune for convenient private transportation with experienced drivers, comfortable AC interiors, practical luggage space, and flexible pickup arrangements. Sedan taxis are suitable for office travel, airport transfers, family journeys, sightseeing, local rides, and outstation trips from Pune."
},
{
"name": "Sedan Cab Booking Pune",
"description": "Make Sedan Cab Booking Pune for scheduled chauffeur-driven transportation with convenient pickup and direct destination drop. Choose a comfortable sedan according to your passenger count, luggage requirements, travel timing, and journey type for local, airport, corporate, tourist, and outstation travel."
},
{
"name": "Sedan Cab Hire Pune",
"description": "Hire Sedan Cab Pune with a professional chauffeur for comfortable and stress-free transportation across Pune and nearby destinations. Enjoy air-conditioned interiors, comfortable seating, practical luggage capacity, and flexible travel options for business trips, family travel, airport transfers, sightseeing, and outstation journeys."
},
{
"name": "Sedan Taxi Booking Pune",
"description": "Reserve Sedan Taxi Booking Pune for reliable private travel with a professional driver and well-maintained AC vehicle. The service is suitable for city transportation, airport pickup and drop, corporate travel, family trips, sightseeing, hotel transfers, and long-distance journeys from Pune."
},
{
"name": "Sedan Car Hire Pune",
"description": "Choose Sedan Car Hire Pune for convenient chauffeur-driven transportation with comfortable seating, AC interiors, luggage space, and scheduled pickup. Sedan cars are suitable for individuals, couples, families, corporate passengers, tourists, airport travelers, and customers planning local or outstation journeys."
},
{
"name": "Sedan Outstation Cab Pune",
"description": "Book Sedan Outstation Cab Pune for comfortable intercity transportation with an experienced chauffeur and clean air-conditioned vehicle. The service is suitable for one-way transfers, round trips, family journeys, business travel, sightseeing, personal visits, and long-distance travel from Pune."
},
{
"name": "Sedan Airport Cab Pune",
"description": "Reserve Sedan Airport Cab Pune for convenient airport pickup and drop transportation with professional chauffeurs and comfortable AC interiors. The sedan provides practical luggage space and reliable scheduled travel for business passengers, families, tourists, individuals, and travelers using Pune Airport."
},
{
"name": "Sedan One Way Cab Pune",
"description": "Book Sedan One Way Cab Pune for a direct point-to-point journey without arranging return transportation. Enjoy convenient pickup, comfortable AC travel, professional chauffeur service, practical luggage space, and suitable transportation for airport drops, intercity travel, business trips, and personal journeys."
},
{
"name": "Sedan Round Trip Cab Pune",
"description": "Choose Sedan Round Trip Cab Pune for convenient return transportation according to your planned itinerary. Enjoy private AC travel, professional chauffeur service, comfortable seating, and flexible pickup arrangements for family trips, business visits, sightseeing, weekend travel, and outstation journeys."
},
{
"name": "Online Sedan Cab Booking Pune",
"description": "Make Online Sedan Cab Booking Pune for convenient scheduled transportation with a professional chauffeur and direct destination drop. Select a comfortable AC sedan for local rides, airport transfers, corporate travel, family journeys, sightseeing, and outstation trips according to your preferred date and timing."
},
{
"name": "Luxury Sedan Cab Pune",
"description": "Book Luxury Sedan Cab Pune for premium chauffeur-driven transportation with comfortable interiors, air conditioning, refined seating, and professional service. The service is suitable for corporate executives, airport transfers, business meetings, special occasions, tourists, and customers seeking a more comfortable private travel experience."
},
{
"name": "Sedan Tourist Cab Pune",
"description": "Choose Sedan Tourist Cab Pune for comfortable sightseeing and private tourist transportation with an experienced chauffeur. The sedan is suitable for couples, families, small groups, visitors, and travelers exploring Pune or nearby destinations with flexible pickup, sightseeing, and travel arrangements."
},
{
"name": "Sedan Cabs in Pune",
"description": "Book Sedan Cabs in Pune for dependable local, airport, corporate, and outstation transportation with comfortable AC vehicles and professional chauffeurs. Sedan options are suitable for individuals, couples, families, tourists, business travelers, and small groups requiring private and convenient transportation."
},
{
"name": "Sedan Taxi Pune",
"description": "Reserve Sedan Taxi Pune for comfortable private travel with experienced chauffeurs, air-conditioned interiors, convenient pickup, and direct destination drop. The service can be used for local rides, airport transfers, office travel, sightseeing, family transportation, hotel transfers, and outstation journeys."
},
{
"name": "Sedan Car on Rent Pune",
"description": "Hire Sedan Car on Rent Pune with a professional chauffeur for flexible and comfortable transportation across Pune and surrounding destinations. Enjoy AC seating, practical luggage space, convenient pickup, and suitable travel arrangements for local trips, airport transfers, business travel, sightseeing, and outstation journeys."
},
{
"name": "Sedan Rental Service Pune",
"description": "Choose Sedan Rental Service Pune for convenient chauffeur-driven car rental with comfortable AC interiors and reliable transportation. The service is suitable for local travel, airport transfers, corporate requirements, family trips, tourist journeys, hotel transportation, one-way transfers, and extended outstation travel."
},
{
"name": "Sedan Cab for Outstation Pune",
"description": "Book Sedan Cab for Outstation Pune for comfortable long-distance travel with a professional chauffeur and well-maintained AC vehicle. Enjoy practical seating, luggage space, convenient pickup, and flexible one-way or round-trip transportation for family journeys, business travel, sightseeing, and personal visits."
},
{
"name": "Pune Airport Sedan Cab",
"description": "Reserve Pune Airport Sedan Cab for convenient transportation to and from Pune Airport with scheduled pickup and professional chauffeur service. The comfortable AC sedan offers practical luggage space and is suitable for business travelers, families, tourists, individuals, and passengers requiring reliable airport transfers."
},
{
"name": "Sedan Taxi for Family Travel",
"description": "Book Sedan Taxi for Family Travel with comfortable AC seating, practical luggage capacity, and an experienced chauffeur. The service is suitable for family outings, airport transfers, hotel transportation, sightseeing, personal visits, and outstation journeys where families prefer private and convenient transportation."
},
{
"name": "Corporate Sedan Taxi Pune",
"description": "Choose Corporate Sedan Taxi Pune for professional chauffeur-driven transportation for office travel, business meetings, client visits, airport transfers, employee movement, and corporate events. Comfortable AC sedan vehicles provide convenient pickup, reliable scheduling, and a practical travel solution for business passengers."
},
{
"name": "Sedan Cab Near Me Pune",
"description": "Book Sedan Cab Near Me Pune for convenient local transportation with flexible pickup and destination drop arrangements. Professional chauffeurs and comfortable AC sedans are suitable for airport transfers, office travel, family journeys, sightseeing, hotel pickups, personal trips, and outstation transportation."
},
{
"name": "Best Sedan Cab Service Pune",
"description": "Choose Best Sedan Cab Service Pune for comfortable chauffeur-driven transportation with clean AC vehicles, experienced drivers, convenient pickup, and flexible journey options. The service is suitable for airport transfers, corporate travel, family trips, sightseeing, local rides, one-way journeys, and outstation transportation."
},
{
"name": "Sedan Cab Service in PCMC",
"description": "Book Sedan Cab Service in PCMC for comfortable local, airport, corporate, and outstation transportation across Pimpri Chinchwad. Enjoy professional chauffeur service, AC interiors, convenient pickup, practical luggage space, and flexible travel options for individuals, families, tourists, and business passengers."
},
{
"name": "Sedan Taxi Pimpri Chinchwad",
"description": "Choose Sedan Taxi Pimpri Chinchwad for reliable private transportation with experienced chauffeurs and well-maintained air-conditioned sedan cars. The service is suitable for city rides, airport transfers, office travel, family journeys, sightseeing, hotel transportation, and outstation trips from PCMC."
},
{
"name": "Sedan Car on Rent PCMC",
"description": "Hire Sedan Car on Rent PCMC with a professional chauffeur for comfortable transportation across Pimpri Chinchwad, Pune, and nearby destinations. Enjoy AC interiors, comfortable seating, luggage space, and flexible travel arrangements for local travel, airport transfers, corporate requirements, sightseeing, and outstation journeys."
},
{
"name": "Sedan Rental Service Pimpri Chinchwad",
"description": "Book Sedan Rental Service Pimpri Chinchwad for convenient chauffeur-driven transportation with comfortable AC vehicles and flexible rental arrangements. The service is suitable for office travel, airport transfers, family trips, tourist transportation, hotel pickups, personal visits, and outstation journeys."
},
{
"name": "PCMC Airport Sedan Cab",
"description": "Reserve PCMC Airport Sedan Cab for comfortable transportation between Pimpri Chinchwad and Pune Airport. Professional chauffeurs provide convenient pickup and drop, AC seating, practical luggage space, and scheduled travel suitable for business passengers, families, tourists, and individuals."
},
{
"name": "Sedan Outstation Taxi PCMC",
"description": "Choose Sedan Outstation Taxi PCMC for comfortable intercity transportation from Pimpri Chinchwad with professional chauffeurs and clean AC vehicles. The service is suitable for one-way transfers, round trips, family travel, business journeys, sightseeing, personal visits, and long-distance transportation."
},
{
"name": "Pimpri Chinchwad Sedan Taxi Service",
"description": "Book Pimpri Chinchwad Sedan Taxi Service for reliable local, airport, corporate, and outstation transportation with experienced drivers and comfortable AC sedan vehicles. Convenient pickup and destination drop make the service suitable for families, professionals, tourists, individuals, and small groups."
},
{
"name": "Sedan Cab Near Me PCMC",
"description": "Choose Sedan Cab Near Me PCMC for convenient private transportation with flexible pickup from residential areas, offices, hotels, and business locations. Comfortable AC sedans with professional chauffeurs are suitable for airport transfers, local rides, family travel, corporate trips, sightseeing, and outstation journeys."
},
{
"name": "Corporate Sedan Cab Service PCMC",
"description": "Book Corporate Sedan Cab Service PCMC for professional transportation for employees, executives, client visits, office meetings, business events, and airport transfers. Enjoy comfortable AC sedan vehicles, trained chauffeurs, convenient pickup arrangements, and dependable transportation across Pimpri Chinchwad and nearby areas."
},
{
"name": "Best Sedan Cab Service in Pimpri Chinchwad",
"description": "Choose Best Sedan Cab Service in Pimpri Chinchwad for comfortable and dependable chauffeur-driven transportation with clean AC vehicles and convenient pickup. The service is suitable for airport travel, corporate requirements, family trips, sightseeing, local rides, one-way journeys, and outstation transportation."
},
{
"name": "Sedan Outstation Cab Pune",
"description": "Book Sedan Outstation Cab Pune for reliable long-distance transportation with a professional chauffeur and comfortable air-conditioned sedan. Enjoy flexible one-way and round-trip travel for family holidays, business visits, sightseeing, personal journeys, airport transfers, and intercity transportation."
},
{
"name": "Sedan Cab Service in Pimpri Chinchwad",
"description": "Choose Sedan Cab Service in Pimpri Chinchwad for comfortable private transportation with professional chauffeurs and well-maintained AC sedan cars. The service is suitable for local travel, airport transfers, office transportation, family trips, sightseeing, hotel transfers, and outstation journeys."
},
{
"name": "Sedan Taxi Service PCMC",
"description": "Reserve Sedan Taxi Service PCMC for convenient chauffeur-driven transportation across Pimpri Chinchwad and nearby destinations. Enjoy comfortable AC interiors, practical luggage space, scheduled pickup, and direct destination drop for local travel, airport transfers, corporate journeys, family trips, and outstation travel."
},
{
"name": "Sedan Cab Booking Pimpri Chinchwad",
"description": "Make Sedan Cab Booking Pimpri Chinchwad for scheduled private transportation with convenient pickup and direct drop facilities. Select a comfortable sedan according to passenger count, luggage requirements, and travel plans for airport transfers, business travel, family journeys, sightseeing, local rides, and outstation trips."
}
],
"tableData": [
["Sedan Cab Service in Pune", "Sedan Taxi Service Pune"],
["Sedan Cab Booking Pune", "Sedan Cab Hire Pune"],
["Sedan Taxi Booking Pune", "Sedan Car Hire Pune"],
["Sedan Outstation Cab Pune", "Sedan Airport Cab Pune"],
["Sedan One Way Cab Pune", "Sedan Round Trip Cab Pune"],
["Online Sedan Cab Booking Pune", "Luxury Sedan Cab Pune"],
["Sedan Tourist Cab Pune", "Sedan Cabs in Pune"],
["Sedan Taxi Pune", "Sedan Car on Rent Pune"],
["Sedan Rental Service Pune", "Sedan Cab for Outstation Pune"],
["Pune Airport Sedan Cab", "Sedan Taxi for Family Travel"],
["Corporate Sedan Taxi Pune", "Sedan Cab Near Me Pune"],
["Best Sedan Cab Service Pune", "Sedan Cab Service in PCMC"],
["Sedan Taxi Pimpri Chinchwad", "Sedan Car on Rent PCMC"],
["Sedan Rental Service Pimpri Chinchwad", "PCMC Airport Sedan Cab"],
["Sedan Outstation Taxi PCMC", "Pimpri Chinchwad Sedan Taxi Service"],
["Sedan Cab Near Me PCMC", "Corporate Sedan Cab Service PCMC"],
["Best Sedan Cab Service in Pimpri Chinchwad", "Sedan Outstation Cab Pune"],
["Sedan Cab Service in Pimpri Chinchwad", "Sedan Taxi Service PCMC"],
["Sedan Cab Booking Pimpri Chinchwad", ""]
],



whychoose: [
  {
    WhyChooseheading: "Sedan Cab Booking in Pune for Comfortable Travel",
    WhyChoosedescription: "Garud Cab Service makes sedan cab booking in Pune convenient for airport transfers, local transportation, business travel, family outings, railway station transfers, and outstation journeys."
  },
  {
    WhyChooseheading: "Book a Sedan According to Your Requirement",
    WhyChoosedescription: "Choose a sedan when you need a practical private vehicle for individuals, couples, small families, or business travellers who prefer comfortable seating and convenient luggage space."
  },
  {
    WhyChooseheading: "Airport Transfers Across Pune",
    WhyChoosedescription: "Arrange a sedan for Pune Airport pickup or drop from your home, hotel, office, railway station area, or another preferred location according to your flight schedule."
  },
  {
    WhyChooseheading: "Convenient for Corporate Travel",
    WhyChoosedescription: "Sedan booking is suitable for client meetings, office visits, business appointments, executive transfers, conferences, and other professional transportation requirements."
  },
  {
    WhyChooseheading: "Local Cab Booking for Daily Needs",
    WhyChoosedescription: "Book a sedan for city sightseeing, shopping, hotel transfers, family visits, railway station travel, medical appointments, social events, and other local transportation needs."
  },
  {
    WhyChooseheading: "Outstation Sedan Booking from Pune",
    WhyChoosedescription: "Plan an outstation journey from Pune to suitable destinations with a private sedan arranged according to your route, travel date, passenger count, and preferred trip type."
  },
  {
    WhyChooseheading: "One-Way, Round-Trip & Multi-Day Options",
    WhyChoosedescription: "Select one-way travel, a return cab, or a multi-day arrangement depending on whether you are travelling for business, sightseeing, family visits, religious trips, or holidays."
  },
  {
    WhyChooseheading: "Quick Reservation with Garud Cab Service",
    WhyChoosedescription: "Share your pickup location, destination, travel date, passenger details, vehicle preference, and trip duration with Garud Cab Service to arrange your sedan cab booking in Pune."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Sedan Cab Booking in Pune?",
    answer: "Yes, Garud Cab Service provides sedan cab booking in Pune for local travel, airport transfers, corporate transportation, family trips, railway station transfers, and outstation journeys."
  },
  {
    question: "Can I book a sedan for Pune Airport?",
    answer: "Yes, sedan cabs can be booked for Pune Airport pickup and drop services according to your flight schedule and preferred pickup time."
  },
  {
    question: "Can I book a sedan for outstation travel?",
    answer: "Yes, sedan cab booking is available for suitable outstation destinations from Pune based on your route, travel dates, passenger count, and vehicle availability."
  },
  {
    question: "Can I book a one-way sedan cab?",
    answer: "Yes, one-way sedan cab service can be arranged when you require direct transportation from Pune to your selected destination."
  },
  {
    question: "Is round-trip sedan booking available?",
    answer: "Yes, round-trip sedan arrangements can be booked for sightseeing, family visits, business travel, religious journeys, airport requirements, and holidays."
  },
  {
    question: "Is sedan cab suitable for family travel?",
    answer: "Yes, sedans are suitable for individuals, couples, and small families who need comfortable private transportation with reasonable luggage space."
  },
  {
    question: "Can companies book sedan cabs for employees or clients?",
    answer: "Yes, businesses can book sedan cabs for employee transportation, client visits, meetings, airport transfers, corporate events, and other professional travel requirements."
  },
  {
    question: "Can I book a sedan for local Pune sightseeing?",
    answer: "Yes, sedan cabs can be arranged for local Pune sightseeing, shopping trips, hotel transfers, family outings, and other city travel requirements."
  },
  {
    question: "Can I book a sedan for multiple days?",
    answer: "Yes, multi-day sedan arrangements can be planned for outstation tours, business travel, family vacations, religious trips, and extended transportation requirements."
  },
  {
    question: "How can I book a Sedan Cab in Pune?",
    answer: "Share your pickup location, destination, travel date, passenger count, preferred sedan, and trip type with Garud Cab Service to confirm your booking."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Kunal Bhosale",
    feedback: "I booked a sedan in Pune for an important business visit. The private cab was comfortable and convenient for travelling between my hotel, office, and airport.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Meenal Joshi",
    feedback: "We booked a sedan for a family outstation trip from Pune. The car was a good fit for our group and the booking process was straightforward.",
    rating: 5
  }
];





  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Sedan Cab Booking Pune",
  "image": "https://garudcabs.com/assets/images/sedan-cab-booking-pune.webp",
  "description": "Book Sedan Cab Booking Pune with Garud Cab for comfortable, air-conditioned, and reliable local, airport, tourist, and outstation travel. Get Sedan cab hire, taxi booking, car rental, one way, round trip, luxury, and airport cab services in Pune with convenient online booking options for family trips, business travel, sightseeing, and intercity journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/sedan-cab-booking-pune"
  }
};



  return (
    <div>


<Helmet>
  <title>Sedan Cab Booking Pune | Taxi, Rental & Airport Cab | +91 9970007784</title>

  <meta
    name="description"
    content="Book Sedan Cab in Pune with Garud Cab for local, airport, tourist, and outstation travel. Get Sedan taxi booking, car hire, rental, one way, round trip, luxury, and airport cab services with easy online booking."
  />

  <meta
    name="keywords"
    content="Sedan Cab Service in Pune, Sedan Taxi Service Pune, Sedan Cab Booking Pune, Sedan Cab Hire Pune, Sedan Taxi Booking Pune, Sedan Car Hire Pune, Sedan Outstation Cab Pune, Sedan Airport Cab Pune, Sedan One Way Cab Pune, Sedan Round Trip Cab Pune, Online Sedan Cab Booking Pune, Luxury Sedan Cab Pune, Sedan Tourist Cab Pune, Sedan Cabs in Pune, Sedan Taxi Pune, Sedan Car on Rent Pune, Sedan Rental Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/42.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Sedancabbookingpune;